import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DragDropRegistry } from '@angular/cdk/drag-drop';

const GRID_ROOT_SELECTOR = '.grid-root';

// Tracks the pointer during CDK drag so drop list enter predicates (which get no coordinates) can hit-test.
// Subscribes to the registry before any DragRef does, so the position is already current when CDK resolves containers.
@Injectable({ providedIn: 'root' })
export class DragPointerService {
    private x = 0;
    private y = 0;

    constructor() {
        inject(DragDropRegistry)
            .pointerMove.pipe(takeUntilDestroyed())
            .subscribe((event: MouseEvent | TouchEvent) => {
                const point = 'touches' in event ? (event.touches[0] ?? event.changedTouches[0]) : event;
                this.x = point.clientX;
                this.y = point.clientY;
            });
    }

    public isOverGridInside(container: HTMLElement): boolean {
        const grid = document.elementFromPoint(this.x, this.y)?.closest(GRID_ROOT_SELECTOR);
        return !!grid && container.contains(grid);
    }
}
